// utils/loadScript.ts
export const loadScript = (
    src: string,
    id: string,
    timeout = 5000
): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (document.getElementById(id)) {
            resolve();
            return;
        }

        const script = document.createElement("script");
        script.src = src;
        script.id = id;
        script.async = true;

        const timer = setTimeout(() => {
            script.remove();
            reject(new Error(`Script load timeout for ${src}`));
        }, timeout);

        script.onload = () => {
            clearTimeout(timer);
            resolve();
        };

        script.onerror = () => {
            clearTimeout(timer);
            reject(new Error(`Script failed to load: ${src}`));
        };

        document.body.appendChild(script);
    });
};
